import numeral from 'numeral'

export const formattedPrice = (price: number | string, format?: string) => {
  if (!price) {
    return price
  }
  return numeral(price)
    .divide(100)
    .format(format ?? '0,0.00')
}

export const formattedNumber = (number: number | string) => {
  return numeral(number).divide(100).format('0,0.00')
}

export const formattedProb = (prob: number | string) => {
  const formatted = numeral(prob).divide(100000000).format('0.0000000%')
  return formatted.replace(/\.?0+%$/, '%').replace(/(\.\d*[1-9])0+%$/, '$1%')
}

export const formattedGem = (gem: number | string) => {
  return numeral(gem).format('0,0')
}
